import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

import { FundWalletCard } from './FundWalletCard';

export const Loading = memo(() => {
    return (
        <FundWalletCard disabled title={<Skeleton width={100} />} description={<Skeleton width={250} />}>
            <Skeleton width={70} />

            <Skeleton width={120} />

            <Skeleton width={70} />
        </FundWalletCard>
    );
});

Loading.displayName = 'Loading';
